import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "_flex _flexcol _gap-2 _mb-3"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_notification_list_item = _resolveComponent("notification-list-item")

  return ($props.notifications.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.notifications, (notification) => {
          return (_openBlock(), _createBlock(_component_notification_list_item, {
            key: notification.key,
            notification: notification
          }, null, 8 /* PROPS */, ["notification"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}